import React from "react";
import { Box } from "@mui/material";

interface PageContainerProps {
  children: React.ReactNode;
  sx?: object;
}

const PageContainer: React.FC<PageContainerProps> = ({ children, sx }) => (
  <Box
    sx={{
      maxWidth: 1200,
      mx: "auto",
      width: "100%",
      mt: 0,
      ...sx,
    }}
  >
    {children}
  </Box>
);

export default PageContainer;
